import { useEditTransactionRuleContext } from './EditTransactionRuleContext';
import {
  EditGeneralSettingsStep,
  EditResponseVisualizationStep,
  EditTransactionModifiersStep,
  EditTransactionSelectorsStep,
} from './steps';
import { EditTransactionRuleStep } from './types';

const stepToComponent = {
  [EditTransactionRuleStep.EditGeneralSettings]: EditGeneralSettingsStep,
  [EditTransactionRuleStep.EditTransactionSelectors]:
    EditTransactionSelectorsStep,
  [EditTransactionRuleStep.EditTransactionModifiers]:
    EditTransactionModifiersStep,
  [EditTransactionRuleStep.EditResponseVisualization]:
    EditResponseVisualizationStep,
};

export const EditTransactionRuleSteps = () => {
  const { step } = useEditTransactionRuleContext();
  const StepComponent = stepToComponent[step];

  return StepComponent ? <StepComponent /> : null;
};
